import axios from "axios";

/** En producción usar mismo origen + `/api` para que Vercel (rewrites) o el host sirvan el backend. */
const BASE_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : `${window.location.origin}/api`;

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // FormData: dejar que el navegador ponga Content-Type con boundary (evita fallos de multer)
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;